<template>
  <div
    class="feature-wrap text-start"
    :style="{ backgroundImage: `url(${bg})` }"
  >
    <div class="feature-block">
      <div class="overlay d-none d-md-block"></div>
      <div
        :class="
          'feature h2-style text-center' +
          ' d-flex flex-column justify-content-center w-100'
        "
      >
        <div>{{ info.title[0] }}</div>
        <template v-if="info.title.length > 1">
          <div>{{ info.title[1] }}</div>
        </template>
      </div>
      <div class="slide-up d-none d-md-block">
        <div class="intro small-text">{{ info.desc }}</div>
      </div>
    </div>
  </div>
  <div class="d-md-none text-start mobile-desc">
    {{ info.desc }}
  </div>
</template>

<script>
import linkArrow from '@/assets/img/link_arrow.png';

export default {
  props: {
    info: { type: Object, required: true },
  },
  data() {
    return {
      linkArrow,
      bg: this.info.image,
    };
  },
};
</script>

<style lang="stylus" scoped>
.feature-wrap
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  // width: 100%;
  height: 500px;
  white-space: normal;

.feature
  height: 400px;
  color: $contract1;

.overlay
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: linear-gradient(180.05deg, rgba(95, 95, 95, 0) 50%, rgba(0, 0, 0, 0.75) 99.96%);
  overflow: hidden;
  width: 100%;
  height: 0;
  transition: all 0.5s ease-in-out;

.feature-block
  width: 100%;
  min-height: 320px;
  height: 100%;
  overflow: hidden;
  transition: all 0.5s ease-in-out;

  &:hover
    .overlay
      top: 0;
      height: 100%;
      mix-blend-mode: alpha;
      transition: all 0.5s ease-in-out;

    .slide-up
      padding-top: 250px;
      transition: all 0.5s ease-in-out;

.slide-up
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: $monoc1;
  padding: 450px 16px 16px 16px;
  z-index: 500;
  transition: all 0.5s ease-in-out;

.intro
  margin-top: 24px;
  margin-bottom: 16px;
  text-align: justify;

.tag-link
  margin-top: 24px;

  img
    width: 36px;
    margin-left: 8px;

.mobile-desc
  padding: 20px 30px;

@media screen and (max-width: 767.5px)
  .feature, .feature-wrap
    height: 240px;

  .mobile-desc
    padding: 20px 10px;
    text-align: justify;
</style>
